export default __webpack_public_path__ + "static/media/car5.f2ded8e8.jpg";